import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Label, Modal, ModalBody, ModalHeader, Row, Table } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import { GetObjByHandWorkCostingStatus } from '_mock/Static_data'
import { dateFormat } from 'pages/Common'

const HandWorkOrderDetailModel = ({ modal, toggle, handWorkOrderId }) => {
    const { getApi } = useApi()
    const [handworkOrderData, setHandWorkOrderData] = useState([])

    useEffect(() => {
        if (handWorkOrderId > 0) {
            getApi(`HandWorkOrder/stitching-details?id=${handWorkOrderId}`).then(({ data, status }) => {
                if (status === 200) {
                    setHandWorkOrderData(data)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
    }, [modal])

    return (
        <Modal isOpen={modal} toggle={toggle} centered={true} size="xl" style={{ width: "900px" }}>
            <div className="modal-content">
                <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                    <span style={{ fontWeight: "600", fontSize: "20px", marginLeft: "8px" }}>Stitching Details </span>
                </ModalHeader>
                <ModalBody>
                    <React.Fragment>
                        <Row>
                            <Col lg="12">
                                <Card>
                                    <CardBody className="p-1">
                                        {/* <Row>
                                            <Col sm="5" className="text-sm-start">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Unique No.: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData[0]?.UniqueNo}
                                                    </span>
                                                </address>
                                            </Col>
                                            <Col sm="7" className="text-end">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Designer: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData[0]?.DesignerByName}
                                                    </span>
                                                </address>

                                            </Col>
                                        </Row> */}
                                        {/* <Row>
                                            <Col sm="5" className="text-sm-start">
                                                <address style={{ marginBottom: "4px" }}>
                                                    <span style={{ fontSize: "15px", fontWeight: "600" }}>
                                                        Order No.: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {handworkOrderData[0]?.OrderNo}
                                                    </span>
                                                </address>
                                            </Col>
                                            <Col sm="7" className="text-end">
                                                <address className="mb-0">
                                                    <span style={{ fontSize: "16px", fontWeight: "600" }}>
                                                        Date: </span>
                                                    <span style={{ fontSize: "14px" }}>
                                                        {dateFormat(handworkOrderData[0]?.CreatedOn?.split("T")[0], "dd-MM-yyyy")}</span>
                                                    <br />
                                                </address>

                                            </Col>
                                        </Row> */}
                                        <div className="table-responsive">
                                            <Table className="table-nowrap" bordered>
                                                <thead>
                                                    <tr>
                                                        <th className="custom-header-invoice" style={{ width: "20px" }}>No</th>
                                                        <th className="custom-header-invoice" style={{ width: "20px" }}>Stitching Master</th>
                                                        <th className="custom-header-invoice" style={{ width: "100%" }}>Stitching Worker</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Stuff Details</th>
                                                        <th className="custom-header-invoice" style={{ width: "40px" }}>Costing</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {handworkOrderData?.length == 0 ?
                                                        <tr>
                                                            <td style={{ textAlign: "center", fontSize: "15px" }} colSpan={5}>
                                                                No Worker
                                                            </td>
                                                        </tr>
                                                        :
                                                        handworkOrderData?.map((item, index) => (
                                                            <tr key={item.Id || index}>
                                                                <td className='custom-header1'>{index + 1}</td>
                                                                <td className='custom-header1'>{item?.StitchingMasterByName || "N/A"}</td>
                                                                <td className='custom-header1'>{item?.StitchingWorkerByName || "N/A"}</td>
                                                                <td className='custom-header1'>
                                                                    {item?.StuffDetails || "N/A"}
                                                                </td>
                                                                <td className='custom-header1'>
                                                                    {item?.Costing || "0.00"}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </React.Fragment >
                </ModalBody>
            </div>
        </Modal >
    )
}

export default HandWorkOrderDetailModel